<template>
  <router-view />
</template>

<script>
export default {
  name: 'api-users-pages-container',
};
</script>
